// base
import React, { Component } from 'react';

// components
import { Accordion, Form, Button, Spinner } from 'react-bootstrap';
import { BsArrowReturnRight } from 'react-icons/bs';
import { HiChevronDoubleRight } from 'react-icons/hi';

import "./ContractAbiViewData.scss";

// api
import { queryContract } from "../../../api";

class ContractAbiViewData extends Component {

  constructor(props) {
    super(props);
    this.state = this.initState(props.abiViewData);
  }

  initState = (abiViewData) => {
    let data = {};
    abiViewData.inputs.forEach(input => {
      data[input.name] = '';
    });

    return {
      queryBtn: {
        disabled: false,
        content: 'Query',
      },
      queryError: null,
      data,
      response: null,
    };
  };

  valueChange = (e) => {
    const { data } = this.state;
    const { name, value } = e.target;
    data[name] = value;

    this.setState({ data });
  };

  getParam = () => {
    const { name, inputs, outputs } = this.props.abiViewData;
    const { data } = this.state;

    let params = {
      name,
      inputs: [],
      outputs: [],
    };

    let isInvalid = inputs.some(input => {
      if (!data[input.name]) {
        return true;
      }

      params.inputs.push({
        type: input.type,
        data: data[input.name],
      })
      return false;
    });

    if (isInvalid) {
      return null;
    }

    outputs.forEach(output => {
      params.outputs.push({
        name: output.name,
        type: output.type,
      });
    });

    return params;
  };

  query = () => {
    this.setState({
      queryBtn: {
        disabled: true,
        content: <Spinner animation="border" />,
      },
      queryError: null,
      response: null,
    });

    let params = this.getParam();
    if (!params) {
      this.setState({
        queryBtn: {
          disabled: false,
          content: 'Query',
        },
        queryError: 'Error: Invalid Parameter.',
      });
      return false;
    }

    const { address, creator } = this.props;
    params.creator = creator;

    queryContract(address, params).then(res => {
      if (res.data) {
        this.setState({
          queryBtn: {
            disabled: false,
            content: 'Query',
          },
          response: res.data,
        });
      }
    }).catch(err => {
      console.error(err);
      const { status, error } = err.response.data;
      this.setState({
        queryBtn: {
          disabled: false,
          content: 'Query',
        },
        queryError: `Error: Query failed. (${status} - ${error})`,
      });
    });
  };

  reset = () => {
    const { abiViewData } = this.props;
    this.setState(this.initState(abiViewData));
  };

  render() {
    const { index, abiViewData, activate, onClick } = this.props;
    const { queryBtn, data, queryError, response } = this.state;
    const { name, inputs, outputs } = abiViewData;

    return (
      <Accordion className="abi-data-accordion" activeKey={`${Number(activate)}`}>
        <Accordion.Item eventKey="1">
          <Accordion.Header onClick={() => onClick(index)}>
            {index+1}. {name}
          </Accordion.Header>
          <Accordion.Body>
            <Form>
            {
              inputs.length > 0 &&
              <>
                {
                  inputs.map((input, i) =>
                    <Form.Group key={i} className="abi-data-input" >
                      <Form.Label>
                        {input.name} ({input.type})
                      </Form.Label>
                      <Form.Control type="text" name={input.name} value={data[input.name]}
                                    onChange={this.valueChange}
                                    placeholder={`${input.name} (${input.type})`} />
                    </Form.Group>
                  )
                }
              </>
            }
            </Form>
            <Button className="query-btn" disabled={queryBtn.disabled} onClick={this.query}>
              {queryBtn.content}
            </Button>
            {
              outputs.length > 0 &&
                outputs.map((output, i) =>
                  <div key={i} className="output-data">
                    <BsArrowReturnRight />
                    {
                      output.name &&
                      <span className="output-data-name">{output.name}</span>
                    }
                    <span className="output-data-type">{output.type}</span>
                  </div>
                )
            }
            {
              response &&
              <div className="query-result">
                <div>[ <strong>{response.name}</strong> method Response ]</div>
                {
                  response.result.map((result, i) =>
                    <div key={i} className="query-result-data">
                      <HiChevronDoubleRight className="text-success" />
                      {
                        result.name &&
                        <span className="query-result-name">{result.name}</span>
                      }
                      <span className="query-result-type">{result.type}</span>:
                      <span className="query-result-value">
                        {
                          result.type.includes('int') ? parseInt(result.value).toLocaleString()
                                                      : result.value
                        }
                      </span>
                    </div>
                  )
                }
              </div>
            }
            {
              queryError &&
              <div className="query-error">{queryError}</div>
            }
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    )
  }
}

export default ContractAbiViewData;
